<template>
    <div id="admin-panel">
        <div class="admin-panel-nav">
            <div class="admin-panel-nav-header">
                <div class="admin-panel-nav-header-logo">
                    <img src="../assets/vinleit-nav-logo-trans.png" alt="">
                </div>
            </div>
            <div class="admin-panel-nav-category-collection">
                <div class="admin-panel-nav-category">
                    <p>Greinar</p>
                </div>
                <div class="admin-panel-nav-items-wrap shadow">
                    <div class="admin-panel-nav-item" v-on:click="currentComp='AdminBlogPosts'">
                        <p>Allar Greinar</p>
                    </div>
                    <div class="admin-panel-nav-item" v-on:click="currentComp='NewBlogPost'">
                        <p>Ný Grein</p>
                    </div>
                </div>

                <div class="admin-panel-nav-category">
                    <p>Vín</p>
                </div>
                <div class="admin-panel-nav-items-wrap shadow">
                    <div class="admin-panel-nav-item" v-on:click="currentComp='AdminWines'">
                        <p>Öll Vín</p>
                    </div>
                    <div class="admin-panel-nav-item" v-on:click="currentComp='NewWine'">
                        <p>Nýtt Vín</p>
                    </div>
                    <div class="admin-panel-nav-item" v-on:click="currentComp='WineMonth'">
                        <p>Vín Mánaðarins</p>
                    </div>
                </div>

                <div class="admin-panel-nav-category">
                    <p>Auglýsingar</p>
                </div>
                <div class="admin-panel-nav-items-wrap shadow">
                    <div class="admin-panel-nav-item" v-on:click="currentComp='AdminAds'">
                        <p>Allar Auglýsingar</p>
                    </div>
                    <div class="admin-panel-nav-item" v-on:click="currentComp='NewAd'">
                        <p>Ný Auglýsing</p>
                    </div>
                </div>

                <div class="admin-panel-nav-category">
                    <p>Annað</p>
                </div>
                <div class="admin-panel-nav-items-wrap shadow">
                    <div class="admin-panel-nav-item" v-on:click="currentComp='AdminMessages'">
                        <p>Skilaboð</p>
                    </div>
                    <div class="admin-panel-nav-item" v-on:click="currentComp='AdminRatings'">
                        <p>Einkunnagjafir</p>
                    </div>
                    <!-- <div class="admin-panel-nav-item">
                        <p>Matur 2</p>
                    </div>
                    <div class="admin-panel-nav-item">
                        <p>Matur 3</p>
                    </div> -->
                </div>
                <!--
                <div class="admin-panel-nav-category">
                    <p>Annað</p>
                </div>
                <div class="admin-panel-nav-items-wrap shadow">
                    <div class="admin-panel-nav-item">
                        <p>Annað 1</p>
                    </div>
                    <div class="admin-panel-nav-item">
                        <p>Annað 2</p>
                    </div>
                    <div class="admin-panel-nav-item">
                        <p>Annað 3</p>
                    </div>
                </div> -->

            </div>
        </div>
        <div class="admin-panel-header">
            <div v-on:click="currentComp='AdminBlogPosts'" class="admin-panel-header-button header-left">
                <img class="header-icon" src="../assets/icons/home.png" alt="">
            </div>
            <div v-on:click="logout" class="admin-panel-header-button header-right">
                <img class="header-icon" src="../assets/icons/logout.png" alt="">
            </div>
            <div class="admin-panel-header-button header-right">
                
            </div>
        </div>
        <div class="comp-wrap">
            <NewBlogPost v-if="currentComp=='NewBlogPost'" v-on:finish="viewBlogs" />
            <AdminBlogPosts v-on:viewBlog="changeComponent" v-if="currentComp=='AdminBlogPosts'"/>
            <ViewBlogPost v-if="currentComp=='ViewBlogPost'" v-bind:blogpost="currentBlog" v-on:finish="viewBlogs" />
            <EditBlogPost v-if="currentComp=='EditBlogPost'" v-bind:blogpost="currentBlog" v-on:finish="viewBlogs" />
            <AdminWines v-if="currentComp=='AdminWines'" v-on:wine="viewWine"/>
            <EditWine v-if="currentComp=='EditWine'" v-bind:wine="currentWine" v-on:finish="viewWines"/>
            <NewWine v-if="currentComp=='NewWine'" v-on:finish="viewWines" />
            <WineMonth v-if="currentComp=='WineMonth'"/>
            <AdminAds v-if="currentComp =='AdminAds'" v-on:ad="viewAd"/>
            <NewAd v-if="currentComp=='NewAd'" v-on:finish="viewAds"/>
            <EditAd v-if="currentComp=='EditAd'" v-bind:ad="currentAd" v-on:finish="viewAds"/>
            <adminMessages v-if="currentComp=='AdminMessages'"/>
            <admin-ratings v-if="currentComp=='AdminRatings'"/>
        </div>
    </div>
</template>

<script>
import NewBlogPost from './NewBlogPost.vue'
import AdminBlogPosts from './AdminBlogPosts.vue'
import ViewBlogPost from './ViewBlogPost.vue'
import EditBlogPost from './EditBlogPost.vue'
import AdminWines from './AdminWines.vue'
import EditWine from './EditWine.vue'
import NewWine from './NewWine.vue'
import WineMonth from './WineMonth.vue'
import AdminMessages from './AdminMessages.vue'
import AdminRatings from './AdminRatings.vue'
import AdminAds from './AdminAds.vue'
import NewAd from './NewAd.vue'
import EditAd from './EditAd.vue'
const fb = require('../firebaseConfig.js')

export default {
    
    data() {
        return { 
            currentComp: "AdminBlogPosts",
            currentBlog: null,
            currentWine: null,
            currentAd: null,
        }
    },
    components: {
        NewBlogPost,
        AdminBlogPosts,
        ViewBlogPost,
        EditBlogPost,
        AdminWines,
        EditWine,
        NewWine,
        WineMonth,
        AdminMessages,
        AdminRatings,
        AdminAds,
        NewAd,
        EditAd,
    },
    methods: {
        changeComponent(...args) {
            const [comp, blog] = args
            this.currentComp = comp
            this.currentBlog = blog
        },
        viewWine(...args) {
            const [comp, wine] = args
            this.currentComp = comp
            this.currentWine = wine
        },
        viewAd(...args) {
            const [comp, ad] = args
            this.currentComp = comp
            this.currentAd = ad
        },
        viewBlogs() {
            this.currentComp = "AdminBlogPosts"
        },
        viewWines() {
            this.currentComp = "AdminWines"
        },
        viewAds() {
            this.currentComp = "AdminAds"
        },
        createCollapse: function() {
            // Set onclick event for collapse sidebar navigation
            var coll = document.getElementsByClassName("admin-panel-nav-category");
            for (var i = 0; i < coll.length; i++) {
                coll[i].addEventListener("click", function() {
                    var prevActive = document.getElementsByClassName("active-nav")[0];
                    if (prevActive && prevActive != this) {
                        prevActive.classList.toggle("active-nav");
                        prevActive.nextElementSibling.style.maxHeight = null;
                    }
                    this.classList.toggle("active-nav");
                    var content = this.nextElementSibling;
                    if (content.style.maxHeight){
                    content.style.maxHeight = null;
                    } else {
                    content.style.maxHeight = content.scrollHeight + "px";
                    } 
                });
            }
        },
        logout() {
            fb.auth.signOut().then(() => {
                this.$store.dispatch('clearData')
                this.$router.push('/login')
            })
        }
    },
    mounted() {
        this.createCollapse()
    }
}
</script>

<style>
.admin-panel {
    margin: 0;
    padding: 0;
}
.admin-panel-nav {
    float:left;
    width:15%;
    height:100vh;
    background-color: rgb(39, 41, 51);
    position: relative;
    z-index: 60;
}
.admin-panel-nav-header {
    height:75px;
    background-image: linear-gradient(to bottom right, #7a2a2c, #bb3b3b );
}
.admin-panel-nav-header-logo {
    height: 55px;
    padding:10px;
    margin:0 auto;
    filter: brightness(0) invert(1);
}
.admin-panel-nav-header-logo img {
    max-height: 100%;
    
}
.admin-panel-nav-category-collection {
    padding-top: 20px;    
    overflow-y: auto;
}

.admin-panel-nav-category {
    height:40px;
    padding: 10px 20px;
    text-align: left;
    color:rgb(137, 140, 155);
    font-size: 18px;
    cursor: pointer;
}
.admin-panel-nav-category:hover {
    color:rgb(182, 186, 206);
}
.admin-panel-nav-category p {
    margin: 0;
}
.admin-panel-nav-items-wrap {
    max-height: 0;
    line-height: 50px;
    overflow: hidden;
    transition: max-height 0.2s ease-out;
    color:rgb(39, 41, 51);
    background-color: #f0f0f0;
}
.admin-panel-nav-item {
    padding-left: 30px;
    text-align: left;
    width: 100%;
    cursor: pointer;
    font-size: 18px;
}
.admin-panel-nav-item:hover { 
    color: rgb(44, 45, 54);
}
.admin-panel-nav-item p { 
    margin: 0;
}

.admin-panel-header {
    float:left;
    background-color: rgb(255, 255, 255);
    width:85%;
    height:75px;
    top:0;
    -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
    -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.1);
    box-shadow: 0 2px 5px 0px rgba(0,0,0,0.1);
    z-index: 50;
}
.admin-panel-header-button {
    display:inline-block;
    height:75px;
    width: 75px;
    cursor: pointer;
}
.header-left {
    float:left;
    border-right: 3px solid rgb(245, 240, 240);
}
.header-right {
    float:right;
    border-left: 3px solid rgb(245, 240, 240);
}
.header-icon {
    height:25px;
    width: 25px;
    margin-top: 25px;
    opacity: 0.5;
}
.comp-wrap {
    position: relative;
    width:85%;
    height: calc(100vh - 75px);
    float:left;
    background-color: #f0f0f0;
    z-index: -50;
    overflow-y: scroll;
}
.shadow {
   -moz-box-shadow:    inset 0 7px 5px -7px #222121, inset 0 -7px 9px -7px #222121;
   -webkit-box-shadow: inset 0 7px 5px -7px #222121, inset 0 -7px 9px -7px #222121;
   box-shadow:         inset 0 7px 5px -7px #222121, inset 0 -7px 9px -7px #222121;
}
</style>